/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Compress controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { CompressImageRequest, RequestOptions, EnqueueImageOperationResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CompressService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    compress(compressImageRequest: CompressImageRequest, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    compress(compressImageRequest: CompressImageRequest, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    compress(compressImageRequest: CompressImageRequest, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    compress(compressImageRequest: CompressImageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/compress`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: compressImageRequest,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    compressAsync(compressImageRequest: CompressImageRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<EnqueueImageOperationResponse>;
    compressAsync(compressImageRequest: CompressImageRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EnqueueImageOperationResponse>>;
    compressAsync(compressImageRequest: CompressImageRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EnqueueImageOperationResponse>>;
    compressAsync(compressImageRequest: CompressImageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/compress/async`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: compressImageRequest,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
